export {
  useEcomStore,
  useUiStore,
  useWishListStore,
  useUiStoreSelector,
  useEcomStoreSelector,
} from './hooks';
export { initialEcomState } from './variables';
